export const capitalizeText = (text = "") => {
	const arr = text.split(" ");
	for (var i = 0; i < arr.length; i++) {
		const upperCase = arr[i].charAt(0).toUpperCase();
		const lowerCase = arr[i].slice(1);
		arr[i] = upperCase;
		for (let j = 0; j < lowerCase.length; j++) {
			const element = lowerCase[j].toLowerCase();
			arr[i] += element;
		}
	}
	return arr.join(" ");
};

export const trimSpaces = (text = "") => {
	return text.replace(/\s/g, "").toLowerCase();
};
